import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from 'environment/environment';

import { BaseListReqParams } from 'modules/shared/models/base.models';
import { OwnRestrictedList, OwnRestrictedName } from 'modules/shared/models/own-restricted-list.models';
import {
  OwnRestrictedListRequest, EditOwnRestrictedListPayload, GetOwnRestrictedListRequest, OwnRestrictedListsResponse,
  AddOwnRestrictedNameRequest, EditOwnRestrictedNameRequest, OwnRestrictedNamesResponse, GetOwnRestrictedNamesRequest,
} from 'store/models/own-restricted-list.models';

@Injectable()
export class OwnRestrictedListService {

  /**
   * Environment variable
   */
  private apiBase: string = environment.API_BASE;

  constructor(private httpClient: HttpClient) { }

  getOwnRestrictedList(restrictedRequest: GetOwnRestrictedListRequest): Observable<OwnRestrictedList> {
    return this.httpClient.get<OwnRestrictedList>(`${this.apiBase}/api/own_sublists/${restrictedRequest.id}/`);
  }

  getOwnRestrictedLists(getOwnRestrictedListsRequest: BaseListReqParams): Observable<OwnRestrictedListsResponse> {
    let params: HttpParams = new HttpParams();
    const url: string = this.apiBase + '/api/own_sublists/';

    const reqBodyEntries: Array<[string, any]> = Object.entries(getOwnRestrictedListsRequest);
    reqBodyEntries.forEach(([key, value]: [string, any]) => {
      if (value !== undefined) {
        params = params.append(key, value);
      }
    });

    return this.httpClient.get<OwnRestrictedListsResponse>(url, { params: params });
  }

  createOwnRestrictedList(restrictedAddRequest: OwnRestrictedListRequest): Observable<OwnRestrictedList> {
    return this.httpClient
      .post<OwnRestrictedList>(`${this.apiBase}/api/own_sublists/`,
                                restrictedAddRequest);
  }

  updateOwnRestrictedList(edtRestrictedAddRequest: EditOwnRestrictedListPayload): Observable<OwnRestrictedList> {
    return this.httpClient
      .patch<OwnRestrictedList>(`${this.apiBase}/api/own_sublists/${edtRestrictedAddRequest.id}/`,
                                edtRestrictedAddRequest.data);
  }

  getRestrictedNames(getOwnRestrictedNamesRequest: GetOwnRestrictedNamesRequest): Observable<OwnRestrictedNamesResponse> {
    let params: HttpParams = new HttpParams();
    const url: string = this.apiBase + `/api/own_sublists/${getOwnRestrictedNamesRequest.listId}/own_names/`;

    const reqBodyEntries: Array<[string, any]> = Object.entries(getOwnRestrictedNamesRequest.data);
    reqBodyEntries.forEach(([key, value]: [string, any]) => {
      if (value !== undefined) {
        params = params.append(key, value);
      }
    });

    return this.httpClient.get<OwnRestrictedNamesResponse>(url, { params: params });
  }

  createRestrictedName(addOwnRestrictedNameRequest: AddOwnRestrictedNameRequest): Observable<OwnRestrictedName> {
    return this.httpClient
      .post<OwnRestrictedName>(`${this.apiBase}/api/own_sublists/${addOwnRestrictedNameRequest.listId}/own_names/`,
                                addOwnRestrictedNameRequest.data);
  }

  editRestrictedName(editOwnRestrictedNameRequest: EditOwnRestrictedNameRequest): Observable<OwnRestrictedName> {
    return this.httpClient
      .patch<OwnRestrictedName>(`${this.apiBase}/api/own_names/${editOwnRestrictedNameRequest.nameId}/`,
                                editOwnRestrictedNameRequest.data);
  }
}
